<h3 class="text-lg font-bold text-center">eJournal Generator</h3>

<div class="relative pb-4">
  <ul class="steps steps-horizontal w-full">
    <li class="step" [class.step-primary]="step() >= 1">Info</li>
    <li
      class="step flex flex-col items-center gap-0.5 min-h-[88px]"
      [class.step-primary]="signerCount() > 0 && step() >= 2"
    >
      Signers
    </li>
    <li class="step" [class.step-primary]="step() >= confirmStep()">Confirm</li>
  </ul>
  @if (signerCount() > 0 && isSignerStep(step())) {
  <p
    class="absolute bottom-0 left-0 text-xs font-normal opacity-80 text-center w-full"
  >
    Signer {{ currentSignerIndex() + 1 }} of {{ signerCount() }}
  </p>
  }
</div>

<!-- Container -->
<div class="flex-1 overflow-auto min-h-0 p-[2px] pt-2 flex flex-col gap-4">
  @if (step() === 1) {
  <!-- Add info step -->
  <et-journal-journal-form
    [packet]="packet"
    [profile]="profile"
    [eJournal]="info"
    [hideButtons]="true"
    [defaultName]="profile.firstName + ' ' + profile.lastName"
    (payloadSubmitted)="saveInfo($event)"
  ></et-journal-journal-form>
  } @else if (isSignerStep(step())) {
  <!-- Add signer step -->
  <et-journal-signer-form
    [signer]="signers[step() - 2]"
    [hideButtons]="true"
    [defaultState]="packet.packetState!"
    [ipAddress]="ipAddress() ?? ''"
    (payloadSubmitted)="saveSigner(step(), $event)"
  ></et-journal-signer-form>
  } @else if (step() === confirmStep()) {
  <!-- Confirm step -->
  <et-journal-packet-card></et-journal-packet-card>

  @for (signer of signers; track signer) { @if (signer) {
  <et-journal-signer-card
    [signer]="signer"
    [isFinalized]="true"
    [hideSignatures]="true"
  ></et-journal-signer-card>
  } } }
</div>

@if (error(); as err) {
<p class="text-error">{{ err }}</p>
}

<!-- Buttons -->
<div class="flex items-center justify-between w-full">
  @if(step() === 1) {
  <!-- Cancel button -->
  <button
    mat-dialog-close
    type="button"
    class="btn btn-outline normal-case rounded-full min-w-[184px] h-10 min-h-[40px]"
  >
    Cancel
  </button>
  } @else {
  <!-- Back button -->
  <button
    type="button"
    class="btn btn-outline normal-case rounded-full min-w-[184px] h-10 min-h-[40px]"
    [disabled]="isSaving()"
    (click)="onPreviousStep()"
  >
    Back
  </button>
  }
  <!-- Next button -->
  @if(step() < totalSteps()) {
  <button
    type="button"
    class="btn btn-primary normal-case rounded-full min-w-[184px] h-10 min-h-[40px]"
    [disabled]="step() >= totalSteps()"
    (click)="onNextStep()"
  >
    Next
  </button>
  } @else {
  <!-- Save button -->
  <button
    type="button"
    class="btn btn-primary normal-case rounded-full min-w-[184px] h-10 min-h-[40px]"
    (click)="onSave()"
  >
    @if (isSaving()) {
    <et-atoms-spinner size="small"></et-atoms-spinner>
    } @else { Save }
  </button>
  }
</div>
